import React from "react";
import upperFirst from "mn-utils/upperFirst";
import {pushLocation} from "../../../../../router";
import {LINK_REFUND_DETAILS, LINK_TRANSACTION_DETAILS, LINK_TRANSACTION_REFUND} from "../../../../../constants/links";
import openPopupEdit from "../../Refund/openPopupEdit";
import generateReceiptTrx from "./generateReceipt";
import generateReceiptRefund from "../../Refund/utils/generateReceipt";
import openPopupCancel from "../../Refund/openPopupCancel";

export const generateActionsList = (data, update) => {
  const KIND_REFUND = 'refund';
  const TRANSACTION_STATUS_COMPLETED = 'completed';

  const {
    paymentId,
    orderId,
    auctionId,
    refundId,
    transactionKind,
    currencyPrefix,
    cryptoCurrencyCode,
    status,
  } = data;

  const isStablecoin = currencyPrefix === 'sc';

  const canBeRefunded = status === TRANSACTION_STATUS_COMPLETED
    && transactionKind !== KIND_REFUND
    && !isStablecoin
    && cryptoCurrencyCode !== 'KLUB';

  return [
    {
      name: 'Details', onClick() {
        pushLocation({
          path: transactionKind === KIND_REFUND
            ? `${LINK_REFUND_DETAILS}/${refundId}`
            : `${LINK_TRANSACTION_DETAILS}/${orderId}/${paymentId}/${auctionId}/${refundId}`,
        });
      },
    },
    ...(data.transactionKind === KIND_REFUND && !isStablecoin && status === 'requested' ? [] : [
      {
        name: 'Receipt', onClick() {
          const fn = data.transactionKind === KIND_REFUND
            ? generateReceiptRefund
            : generateReceiptTrx;

          fn({
            ...data,
            transactionKind: upperFirst(transactionKind || '').split('_').join(' ')
          });
        },
      }
    ]),
    ...(canBeRefunded ? [
      {
        name: 'Refund', onClick() {
          pushLocation({
            path: `${LINK_TRANSACTION_REFUND}/${orderId}/${paymentId}`,
          });
        },
      },
    ] : []),
    ...(data.transactionKind === KIND_REFUND && !isStablecoin && status === 'requested' ? [
      {
        name: 'Edit', onClick() {
          openPopupEdit(data, update);
        },
      },
    ] : []),
    ...(data.transactionKind === KIND_REFUND && !isStablecoin && status === 'requested' ? [{
      name: (<div className="cF00">Cancel</div>),
      onClick() {
        openPopupCancel(data.refundId, update);
      },
    }] : []),
  ];
}
